import type { FaireProductEntity } from "../../entity_types/product";

export const p_ds9sm4qn23: FaireProductEntity = {
  token: "p_ds9sm4qn23",
  type: "product",
  name: "Casual shirt collar and two dresses",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/c9bfcce316418a3d6151a4d0e37380ebd92b544df82293c3317023fc6fe80e6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1a8ccb01642d25342620e9c97da83a5dbe90ec6dc80ccdd11aadd4194266ecb.jpeg",
    "https://cdn.faire.com/fastly/c3fdfafdb6be886fca09fa682969caaf7f8a8e085c643a344b7a5b69eebedc36.jpeg",
    "https://cdn.faire.com/fastly/1e1ffac928997d225425e6801532e516c1d6c0fc5b6340380efabefc4f589d97.jpeg",
    "https://cdn.faire.com/fastly/eecd7b8f2234f54053a32e67586d3090bc764083263d3cc5f9d0c5bf240d227f.jpeg",
    "https://cdn.faire.com/fastly/f62a82361db38a740a4166d3c3268187b23a884576a4fdb20108c6d6683bbb77.jpeg",
    "https://cdn.faire.com/fastly/d166f9179f2bc5f7d0238d1a03d0ab7f78930217835c517e2a5ff9239b47a952.jpeg",
  ],
  priceDollars: 24.08,
  description:
    "Casual shirt collar and two dresses\n• 70% linen, 30% polyester\n• Sizes: S, M, L, XL, XXL\n• Made in China\n\nDress, spring dress, Summer dress, Fall dress, Winter dress, dress pants, dress front, dress pocket, lesbian dress, dress mature women, mid-length dress, dress, large dress, split skirt, floor dress, high-waist dress, Mid-waist dress, Tunic dress, tunic dress, Western dress, Spring dress, Summer dress, long-sleeved dress, short-sleeved dress, patchwork dress, halter dress, vest dress, cutout dress, crew-neck dress, line-neck dress, V-neck dress, wedding dress, Wedding dress, Homecoming dress, Bridesmaid dress, Cocktail dress, Prom dress, denim dress, Midi dress, graduation dress, ski dress, sequin dress, gown, spring 2025 clothing",
  tags: [],
  msrpDollars: 48.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:10.801Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
